import { createAction } from "redux-act";

export const ErrorOpenModalAction = createAction<any>("Error - Open Modal");
export const ErrorCloseModalAction = createAction("Error - Close Modal");
